import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';
//新增学校评估模板（json）
export function insertAssessTemplate(args) {   
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/growthAssess/insertAssessTemplate',
        method: 'post',
        data: JSON.stringify(args)
    });
  }
//关闭或启用学校评估模板
export function enableAssessTemplate(enable,id,level,levelName,term) {
    let params = new URLSearchParams();
    params.append('enable', enable);
    params.append('id', id);
    params.append('level', level);
    params.append('levelName', levelName);
    params.append('term', term);
    return fetch({
      url: 'structure/growthAssess/enableAssessTemplate',
      method: 'post',
      data: params
    });
  }
  //获取学校评估模板详情
export function getAssessTemplateById(assessTempId) {
    let params = new URLSearchParams();
    params.append('assessTempId', assessTempId);
    return fetch({
      url: 'structure/growthAssess/getAssessTemplateById',
      method: 'get',
     params
    });
  }
  //获取学校评估模板
export function getAssessTemplateBySchoolId(searchName) {
    let params = new URLSearchParams();
    params.append('searchName', searchName);
    return fetch({
        url: 'structure/growthAssess/getAssessTemplateBySchoolId',
        method: 'get',
        params
    });
  }
  //编辑学校评估模板题目
 export function editAssessTemplateQuestion(args) {
    let params = new URLSearchParams();
    params.append('assessTempId', args.assessTempId);
    params.append('domainId', args.domainId);
    params.append('id', args.id);
    params.append('question', args.question);
    params.append('questionNo', args.questionNo);
    return fetch({
      url: 'structure/growthAssess/editAssessTemplateQuestion',
      method: 'post',
      data: params
    });
  }
   //新增学校评估模板题目
   export function insertAssessTemplateQuestion(args) {
    let params = new URLSearchParams();
    params.append('assessTempId', args.assessTempId);
    params.append('domainId', args.domainId);
    params.append('question', args.question);
    params.append('questionNo', args.questionNo);
    return fetch({
      url: 'structure/growthAssess/insertAssessTemplateQuestion',
      method: 'post',
      data: params
    });
  }

   //删除评估模板领域
export function deleteAssessTemplateDomainById(id) {
    let params = new URLSearchParams();
    params.append('id', id);
    return fetch({
      url: 'structure/growthAssess/deleteAssessTemplateDomainById',
      method: 'get',
     params
    });
  }
   //新增评估模板领域
   export function insertAssessTemplateDomain(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/growthAssess/insertAssessTemplateDomain',
        method: 'post',
        data: JSON.stringify(args)
    });
  }
   //新增评估模板领域
   export function editAssessTemplateDomain(args) {
    return fetch({
      headers: {
          'content-type': 'application/json'
      },
      url: 'structure/growthAssess/editAssessTemplateDomain',
      method: 'post',
      data: JSON.stringify(args)
  });
  }
    //新增排版
    export function addGrowthBookCompose(args) {
      let params = new URLSearchParams();
      params.append('backLogo', args.backLogo);
      params.append('composeNo', args.composeNo);
      params.append('fontColor', args.fontColor);
      params.append('xPhotoNum', args.xPhotoNum);
      params.append('yPhotoNum', args.yPhotoNum);
      return fetch({
        url: 'structure/growthBookAssembly/addGrowthBookCompose',
        method: 'post',
        data: params
      });
    }

    //查询成长册排版列表
export function getGrowthBookComposeList() {
  return fetch({
      url: 'structure/growthBookAssembly/getGrowthBookComposeList?state=0',
      method: 'get'
  });
}
 //根据ID删除成长册排版
 export function delGrowthBookComposeById(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
    url: 'structure/growthBookAssembly/delGrowthBookComposeById',
    method: 'get',
   params
  });
}

  //查询组件列表
  export function getGrowthBookAssemblyList() {
    return fetch({
        url: 'structure/growthBookAssembly/getGrowthBookAssemblyList',
        method: 'get'
    });
  }
  //新增组件背景
  export function addGrowthBookAssemblyLogo(args) {
    let params = new URLSearchParams();
    params.append('assemblyCode', args.assemblyCode);
    params.append('backCoverLogo', args.backCoverLogo);
    params.append('coverLogo', args.coverLogo);
    params.append('effectLogo', args.effectLogo);
    params.append('fontColor', args.fontColor);
    params.append('logoCode', args.logoCode);
    params.append('logoName', args.logoName);
    params.append('titlePageLogo', args.titlePageLogo);
    return fetch({
      url: 'structure/growthBookAssembly/addGrowthBookAssemblyLogo',
      method: 'post',
      data: params
    });
  }
 //编辑组件背景
 export function editGrowthBookAssemblyLogo(args) {
  let params = new URLSearchParams();
  params.append('assemblyCode', args.assemblyCode);
  params.append('backCoverLogo', args.backCoverLogo);
  params.append('coverLogo', args.coverLogo);
  params.append('effectLogo', args.effectLogo);
  params.append('fontColor', args.fontColor);
  params.append('logoCode', args.logoCode);
  params.append('logoName', args.logoName);
  params.append('titlePageLogo', args.titlePageLogo);
  params.append('id', args.id);
  return fetch({
    url: 'structure/growthBookAssembly/editGrowthBookAssemblyLogo',
    method: 'post',
    data: params
  });
}
 //删除组件背景
 export function delGrowthBookAssemblyLogoById(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
    url: 'structure/growthBookAssembly/delGrowthBookAssemblyLogoById',
    method: 'get',
   params
  });
}
//根据ID查询组件背景详细信息
export function getGrowthBookAssemblyLogoById(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
    url: 'structure/growthBookAssembly/getGrowthBookAssemblyLogoById',
    method: 'get',
   params
  });
}
//根据组件编码查询组件背景列表
export function getGrowthBookAssemblyLogoListByAssemblyCode(assemblyCode) {
  let params = new URLSearchParams();
  params.append('assemblyCode', assemblyCode);
  return fetch({
    url: 'structure/growthBookAssembly/getGrowthBookAssemblyLogoListByAssemblyCode',
    method: 'get',
   params
  });
}
//根据父级组件ID查询子背景列表
export function getGrowthBookAssemblyChildLogoListByPid(pid) {
  let params = new URLSearchParams();
  params.append('pid', pid);
  return fetch({
    url: 'structure/growthBookAssembly/getGrowthBookAssemblyChildLogoListByPid',
    method: 'get',
   params
  });
}
//删除组件背景子背景
export function delGrowthBookAssemblyChildLogoById(id) {
 let params = new URLSearchParams();
 params.append('id', id);
 return fetch({
   url: 'structure/growthBookAssembly/delGrowthBookAssemblyChildLogoById',
   method: 'get',
  params
 });
}
 //新增组件背景
 export function addGrowthBookAssemblyChildLogo(args) {
  let params = new URLSearchParams();
  params.append('code', args.code);
  params.append('coverLogo', args.coverLogo);
  params.append('dateColor', args.dateColor);
  params.append('fontColor', args.fontColor);
  params.append('pid', args.pid);
  return fetch({
    url: 'structure/growthBookAssembly/addGrowthBookAssemblyChildLogo',
    method: 'post',
    data: params
  });
}
 //编辑组件背景子背景
 export function editGrowthBookAssemblyChildLogo(args) {
  let params = new URLSearchParams();
  params.append('code', args.code);
  params.append('coverLogo', args.coverLogo);
  params.append('dateColor', args.dateColor);
  params.append('fontColor', args.fontColor);
  params.append('pid', args.pid);
  params.append('id', args.id);
  return fetch({
    url: 'structure/growthBookAssembly/editGrowthBookAssemblyChildLogo',
    method: 'post',
    data: params
  });
}

//新增学校评估模板题目
export function editAssessTemplate(args) {
  let params = new URLSearchParams();
  params.append('remark', args.remark);
  params.append('id', args.id);
  params.append('title', args.title);
  return fetch({
    url: 'structure/growthAssess/editAssessTemplate',
    method: 'post',
    data: params
  });
}
//删除学校评估模板题目
export function deleteAssessTemplateQuestionById(questionId) {
  let params = new URLSearchParams();
  params.append('questionId', questionId);
  return fetch({
    url: 'structure/growthAssess/deleteAssessTemplateQuestionById',
    method: 'get',
   params
  });
 }

  //新增学校评估模板题目
  export function updateGrowthBookComposeState(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('state', args.state);
    return fetch({
      url: 'structure/growthBookAssembly/updateGrowthBookComposeState',
      method: 'post',
      data: params
    });
  }


// WEBPACK FOOTER //
// ./src/api/growthfootprint.js